import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppRoutingModule} from './app-routing.module';
import {FullCalendarModule} from '@fullcalendar/angular';

import {AppComponent} from './app.component';
import {AppMainComponent} from './app.main.component';
import {AppTopBarComponent} from './app.topbar.component';
import {AppConfigComponent} from './app.config.component';
import {AppMenuComponent} from './app.menu.component';
import {AppMenuitemComponent} from './app.menuitem.component';
import {AppNotfoundComponent} from './pages/app.notfound.component';
import {AppErrorComponent} from './pages/app.error.component';
import {AppAccessdeniedComponent} from './pages/app.accessdenied.component';
import {AppLoginComponent} from './pages/app.login.component';

import {BreadcrumbService} from './app.breadcrumb.service';
import {MenuService} from './app.menu.service';

import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import {FormlyModule} from '@ngx-formly/core';
import {FormlyFieldCheckbox, FormlyPrimeNGModule} from '@ngx-formly/primeng';
import {SharedModule} from '@shared/shared.module';
import {ConfirmationService, MessageService} from 'primeng/api';
import {JwtInterceptor} from '@app/@core/interceptors/jwt.interceptor';
import {ErrorInterceptor} from '@app/@core/interceptors/error.interceptor';
import {LoaderInterceptor} from '@app/@core/interceptors/loader.interceptors';
import {FormlyFieldCalendar} from '@shared/components/formly-field-primeng-calendar';
import {FormlyFieldMultiSelect} from '@shared/components/formly-field-primeng-multiselect';
import {FormlyFieldListBox} from '@shared/components/formly-field-primeng-listbox';
import {FormlyFieldFile} from '@shared/components/formly-field-file.component';
import {FormlyFieldTabs} from '@shared/components/formly-field-primeng-tabs';
import {FormlyWrapperFormField} from '@shared/components/form-field.wrapper';
import {FormlyWrapperNon} from '@shared/components/form-field-nowrapper';
import {RepeatTypeComponent} from '@shared/components/repeat-section.type';
import {FormlyFieldChips} from '@shared/components/formly-field-primeng-chipst';
import {OrderModule} from 'ngx-order-pipe';
import {HomeConfigDetailComponent} from '@app/modules/app-config/home-config-detail/home-config-detail.component';
import {AppConfigModule} from '@app/modules/app-config/app-config.module';
import {LoggerModule, NgxLoggerLevel} from 'ngx-logger';
import {DatePipe, DecimalPipe} from '@angular/common';
import {DialogService} from 'primeng/dynamicdialog';
import {NgPipesModule} from 'ngx-pipes';
import {FormlyFieldCourseSelect} from '@shared/components/formly-field-course-select';
import {FormlyFieldFileInputType} from '@shared/components/formly-field-file-input-type.component';
import {FormlyCenterWrapper} from '@shared/components/form-field-center.wrapper';
import {BreadcrumbModule} from 'xng-breadcrumb';
import {NgxPermissionsModule} from 'ngx-permissions';
import {NumberValidatorMessage, TimeFormatValidator, TimeFormatValidatorMessage} from '@shared/helper/formly-helpers';
import {NgToggleModule} from 'ng-toggle-button';
import {FormlyFieldHtml} from '@shared/components/formly-field-html';
import {FormlyWrapperFormFieldOffset3} from '@shared/components/form-field-offset-3.wrapper';
import {CustomSelectComponent} from '@shared/components/formly/custom-select/custom-select.component';
import Handsontable from 'handsontable';

Handsontable.cellTypes.registerCellType('handsontable', Handsontable.cellTypes.getCellType('handsontable'));


FullCalendarModule.registerPlugins([
    dayGridPlugin,
    timeGridPlugin,
    interactionPlugin
]);

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        // /NgPrimeModule,
        SharedModule,
        FormlyModule.forRoot({
            wrappers: [
                {name: 'form-field', component: FormlyWrapperFormField},
                {name: 'no-wrap', component: FormlyWrapperNon},
                {name: 'center', component: FormlyCenterWrapper},
                {name: 'offset-3', component: FormlyWrapperFormFieldOffset3},
            ],
            types: [
                {name: 'datepicker', component: FormlyFieldCalendar, wrappers: ['form-field']},
                {name: 'repeat', component: RepeatTypeComponent, wrappers: ['form-field']},
                {name: 'multiselect', component: FormlyFieldMultiSelect, wrappers: ['form-field']},
                {name: 'listbox', component: FormlyFieldListBox, wrappers: ['form-field']},
                {name: 'file', component: FormlyFieldFile, wrappers: ['form-field']},
                {name: 'file-input', component: FormlyFieldFileInputType, wrappers: ['form-field']},
                {name: 'tabs', component: FormlyFieldTabs, wrappers: ['form-field']},
                {name: 'chips', component: FormlyFieldChips, wrappers: ['form-field']},
                {name: 'course-select', component: FormlyFieldCourseSelect, wrappers: ['form-field']},
                {name: 'custom-select', component: CustomSelectComponent, wrappers: ['form-field']},
                {name: 'html', component: FormlyFieldHtml, wrappers: ['form-field']},
                {name: 'checkbox', component: FormlyFieldCheckbox, wrappers: ['offset-3']},
            ],
            validators: [{name: 'time', validation: TimeFormatValidator}],
            validationMessages: [
                {name: 'time', message: TimeFormatValidatorMessage},
                {name: 'number', message: NumberValidatorMessage},
            ],
        }),
        FormlyPrimeNGModule,
        OrderModule,
        NgPipesModule,
        AppConfigModule,
        BreadcrumbModule,
        NgxPermissionsModule.forRoot(),
        LoggerModule.forRoot({level: NgxLoggerLevel.DEBUG}),
        NgToggleModule.forRoot(),
    ],
    declarations: [
        AppComponent,
        AppMainComponent,
        AppTopBarComponent,
        AppConfigComponent,
        AppMenuComponent,
        AppMenuitemComponent,
        AppLoginComponent,
        AppNotfoundComponent,
        AppErrorComponent,
        AppAccessdeniedComponent,
        HomeConfigDetailComponent
    ],
    providers: [
        // {provide: LocationStrategy, useClass: HashLocationStrategy},
        {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true},
        MessageService,
        ConfirmationService,
        DialogService,
        MenuService,
        BreadcrumbService,
        DatePipe,
        DecimalPipe
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
